import styled from 'styled-components';

export const PrinterStationConfigStatus = styled.div`
  font-size: ${props => props.theme.typography.fontSize.medium};
  font-family: ${props => props.theme.typography.fontFamily};
  margin-top: 16px;
  display: flex;
  gap: 12px;
  align-items: center;

  & > span:last-child {
    margin-left: -4px;
  }
`;

export const PrinterStationConfigStatusLabel = styled.span`
  color: ${props => props.theme.palette.text.primary};
`;

export const PrinterStationConfigStatusIcon = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  flex-shrink: 0;
  color: ${props => props.theme.palette.text.primary};

  & svg {
    font-size: 20px;
  }
`;

export const PrinterStationConfigStatusValue = styled.span<{ available: boolean }>`
  color: ${props => props.available ? props.theme.palette.success.regular : props.theme.palette.error.main};
  font-weight: bold;
`;
